import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { P } from "const/permissions";
import { getApiError } from "utils/apiError";
import { hasPermission } from "utils/permissionUtils";
import RecordPaymentForm from "./RecordPaymentForm";
import { invalidateModuleFinance } from "./moduleFinanceQueries";
import { addModulePayment } from "./modulePaymentsApi";
import { requiresPaymentMethod } from "./modulePaymentsConstants";

const RecordModulePaymentDialog = ({
  open,
  moduleType,
  moduleId,
  clientId,
  onClose,
  onRecorded,
}) => {
  const queryClient = useQueryClient();
  const add = useMutation({
    mutationFn: (payload) => addModulePayment(moduleType, moduleId, payload),
    onSuccess: (_, payload) => {
      toast.success(
        payload.autoVerify ? "Payment recorded and verified" : "Payment submitted for verification"
      );
      invalidateModuleFinance(queryClient, moduleType, moduleId, clientId);
      onRecorded?.();
      onClose();
    },
    onError: (err) => toast.error(getApiError(err, "Failed to submit payment")),
  });

  return (
    <Dialog open={open} onClose={add.isLoading ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Record payment</DialogTitle>
      <DialogContent dividers>
        {open && (
          <RecordPaymentForm
            requireMethod={requiresPaymentMethod(moduleType)}
            canSelfVerify={hasPermission(P.ACCOUNTS.PAYMENT_VERIFY)}
            submitting={add.isLoading}
            onSubmit={(payload) => add.mutate(payload)}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default RecordModulePaymentDialog;
